import MachineRunningWidgetContainer from "./MachineRunningWidgetContainer";
export type { MachineRunningApiResponse } from "./MachineRunning";

export default MachineRunningWidgetContainer;
